export default __webpack_public_path__ + "static/media/home_icon.88f2841b.svg";